// lib
import { connect } from 'react-redux';

// components
import View from './View';

// redux
import { getCMSData } from 'shared/store/cms/selectors';

const mapStateToProps = (state: any) => {
  const cmsData = getCMSData(state);
  const { content, jsContent } = cmsData;
  const jsContentValue = jsContent && JSON.parse(jsContent);
  return {
    content: content,
    jsContent: jsContentValue,
  };
};

export default connect(mapStateToProps)(View);
